<div class="page-layout carded left-sidenav toolbar-fixed-layout"> <!-- fusePerfectScrollbar -->

  <!-- HEADER -->

  <mat-sidenav-container>
    <div class="center">
      <div class="content-card mat-white-bg">
        <div *ngIf="matchingCountry" class="match-country-error">
          <i class="fal fa-info-circle m-r-8"></i>
          Please, select different Paying and Receiving Entity!
        </div>

        <div class="content p-lr-30 p-b-30 p-t-27 flex flex-col">


          <form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
                class="flex flex-col full-grow-no-shrink-no-basis">
            <div class="flex flex-row justify-start items-start">

              <mat-form-field appearance="outline" class="m-r-20 full-grow-no-shrink-no-basis">
                <mat-label>Paying Entity</mat-label>
                <input matInput formControlName="payingCountry" matInput placeholder="Paying  Entity*"
                       (click)="showPayingCountryDialogue()" readonly/>
              </mat-form-field>

              <mat-form-field appearance="outline" class="m-r-20 full-grow-no-shrink-no-basis">
                <mat-label>Receiving Entity</mat-label>
                <input matInput formControlName="receivingCountry" matInput placeholder="Receiving  Entity*"
                       (click)="showReceivingCountryDialogue()" readonly/>
              </mat-form-field>

            </div>

            <div class="flex flex-row">

              <mat-form-field appearance="outline" class="m-r-20 full-grow-no-shrink-no-basis">
                <mat-label>Type of Payment</mat-label>
                <mat-select formControlName="typeofPayment">
                  <mat-option *ngFor="let type of paymentStream" [value]="type.code">
                    {{type.title}}
                  </mat-option>
                </mat-select>
                <mat-error>
                  Field name is required!
                </mat-error>
              </mat-form-field>


              <mat-form-field appearance="outline" class="m-r-20 full-grow-no-shrink-no-basis"
                              *ngIf="availablePercentage">
                <mat-label>Ownership %</mat-label>
                <mat-select formControlName="holdingPercentage">
                  <mat-option *ngFor="let percentage of availablePercentage" [value]="percentage">
                    {{percentage}}
                  </mat-option>
                </mat-select>
              </mat-form-field>


              <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis" *ngIf="availablePeriods">
                <mat-label>Holding Period (month)</mat-label>
                <mat-select formControlName="holdingPeriod">
                  <mat-option *ngFor="let period of availablePeriods" [value]="period">
                    {{period}} months
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </form>

        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>
